var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8501 30.05H35.1501",
    stroke: "#3DC8AF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.8501 19.85H35.1501",
    stroke: "#3DC8AF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.8501 40.25H27.5001",
    stroke: "#3DC8AF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2 45.35V9.65002",
    stroke: "#3DC8AF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M53 45.35V9.65002",
    stroke: "#3DC8AF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.3501 37.7C45.3501 44.9124 45.3501 48.5186 43.1095 50.7593C40.8688 53 37.2626 53 30.0501 53H24.9501C17.7376 53 14.1314 53 11.8908 50.7593C9.65015 48.5186 9.65015 44.9124 9.65015 37.7V27.5M9.65015 17.3C9.65015 10.0875 9.65015 6.48127 11.8908 4.24063C14.1314 2 17.7376 2 24.9501 2H30.0501C37.2626 2 40.8688 2 43.1095 4.24063C45.3501 6.48127 45.3501 10.0875 45.3501 17.3V27.5",
    stroke: "#3DC8AF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.67eda0bc26de7a4bc6487abbaff9a4e8.svg";
export { ForwardRef as ReactComponent };